import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Calendar } from "../../../../global/calendar/Calendar";
import { useModalCalendarContext } from "./ListingModalCalendarProvider";
import { useListingModalCalendarInvalidDate } from "../../../../../hooks/trainingPlan/useListingModalCalendarInvalidDate";
import { ListingModalCalendarWrapper } from "./ListingModalCalendarWrapper";
import { ListingModalCalendarButtonsWrapper } from "./ListingModalCalendarButtonsWrapper";
import { ListingModalCalendarScheduleBtn } from "./ListingModalCalendarScheduleBtn";

export const ListingModalCalendar = () => {
  const minDate = dayjs(new Date());
  const { dispatch } = useModalCalendarContext();

  useListingModalCalendarInvalidDate();

  return (
    <ListingModalCalendarWrapper>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Calendar
          value={minDate}
          minDate={minDate}
          onChange={(value) => {
            dispatch({ dateValue: value });
          }}
        />
      </LocalizationProvider>

      <ListingModalCalendarButtonsWrapper>
        <ListingModalCalendarScheduleBtn />
      </ListingModalCalendarButtonsWrapper>
    </ListingModalCalendarWrapper>
  );
};
